import { Col, Divider, Modal, Row, Slider, Space, Tag, InputNumber, Button } from "antd";
import { Form, Formik } from "formik";
import { useEffect, useState } from "react";

import { DatePicker, Input, RadioGroup, Select } from "components/form";
import styles from "../styles/HolidayCalendarFilter.module.css";
import useStatusFlagOption from "components/elements/Select/StatusDropdown";
import { useTranslation } from "react-i18next";

const AttendenceFilter = ({
  holidayCalendarGroupId,
  initialValues = {},
  shiftOptions = [],
  titleNameOptions = [],
  employeeTypeOptions = [],
  modifiedPositionOptions = [],
  organizationUnderOptions = [],
  welfareList = [],
  provinceOptionsTh = [],
  provinceOptionsEn = [],
  welfareOption = [],
  welfareTypeOptions = [],
  leaveGroupOptions = [],
  dataFlag = null,
  roleOption = [],
  deviceTypeOptions = [],
  shiftDropDown = [],
  onCancel = () => { },
  onSubmit = () => { },
  onSearch = () => { },
}) => {
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const [optionType, setOptionType] = useState(null);
  const [defaultDate, setDefaultDate] = useState(null);

  const setDate = new Date().getFullYear().toString();
  const { modifiedStatus = [] } = useStatusFlagOption()
  const currentYear = new Date().getFullYear();
  const buddhistYearOffset = 543;

  const yearOptions = Array.from({ length: 10 }, (_, index) => {
    const year = currentYear + index;
    const formattedYear =
      i18n.language === "en" ? year : year + buddhistYearOffset;

    return { value: year, label: formattedYear };
  });
  // Set initial values including the default year
  const initialFormValues = {
    ...initialValues,
    year: initialValues.year || currentYear,
  };
  console.log("onSead ", initialFormValues);
  const statusOption = [
    {
      label: t('status.all'),
      value: null,
      name: "All"
    },
    {
      label: t(`status.active`),
      value: "ACTIVE",
      name: "Active"
    },
    {
      label: t(`status.inactive`),
      value: "INACTIVE",
      name: "Inactive"
    }
  ]

  return (

    <Formik
      initialValues={{
        ...initialFormValues,
        statusFlag: null,
      }}

      onSubmit={
        ((values) => {

          onSubmit(values)
        })
      }

    // validationSchema={schema}
    >
      {({ resetForm, values = {}, setFieldValue = () => { }, setTouched = () => { } }) => {
        return (

          <Form>
            {dataFlag == "holiday" && (
              <Row gutter={[24, 16]} className={styles.filter} >
                <Col span={12}>
                </Col>
                <Col span={6}>
                  <Select
                    name="year"
                    label={t('translation.year')}
                    size="large"
                    options={yearOptions}
                  />
                </Col>

                <Col span={6}>
                  <Select
                    name="statusFlag"
                    label={t('translation.status')}
                    placeholder={t('translation.status')}
                    size="large"
                    options={statusOption}
                  />
                </Col>

              </Row>
            )}
            {dataFlag == "workinType" && (
              <Row gutter={[24, 16]} className={styles.filter} >
                <Col span={8}>
                  <Input
                    name="workInLocationName"
                    label={t('attendance.label.workinlocation')}
                    placeholder={t('attendance.label.workinlocation')}
                    size="large"
                  />
                </Col>
                <Col span={8}>
                  <Select
                    name="deviceTypeId"
                    // label={t('translation.worktype')}
                    placeholder={t('please-select-1')}
                    size="large"
                    label={
                      t("workin_location.label.device_type")
                    }
                    options={deviceTypeOptions}

                    onChange={(val) => {
                      const device =
                        (
                          deviceTypeOptions.find(
                            (d) => d.value === val
                          ) || {}
                        ).id || "";
                      setFieldValue("deviceType", device);
                    }}
                  />
                </Col>
                <Col span={8}>
                  <Select
                    name="statusFlag"
                    label={t('translation.status')}
                    placeholder={t('please-select-1')}
                    size="large"
                    options={modifiedStatus}

                  />
                </Col>

              </Row>
            )}
            {dataFlag == "leaveType" && (
              <Row gutter={[24, 16]} className={styles.filter} >
                {/* <Col span={8}>
                  <Input
                    disabled={values.isView}
                    name="leaveTypeName"
                    label={t('attendance.label.leave_type_name')}
                    placeholder={t('attendance.label.leave_type_name')}
                    size="large"
                  />

                </Col> */}
                <Col span={12}>
                  <Select
                    disabled={values.isView}
                    name="leaveGroupId"
                    label={t('attendance.label.leave-category')}
                    placeholder={t('attendance.label.leave-category')}
                    size="large"
                    options={leaveGroupOptions}
                    onChange={(_, opt) => {
                      setFieldValue("leaveGroupName", opt.nameEn);
                    }}
                  />
                </Col>

                <Col span={12}>
                  <Select
                    name="statusFlag"
                    label={t('translation.status')}
                    placeholder={t('translation.status')}
                    size="large"
                    options={modifiedStatus}
                  />
                </Col>

              </Row>
            )}
            {dataFlag == "shift" && (
              <Row gutter={[24, 16]} className={styles.filter} >
                <Col span={8}>
                  <Input
                    name="shiftName"
                    label={
                      t("shift.label.shift_name")
                    }
                    placeholder={
                      t("shift.placeholders.shift_name")
                    }
                    size="large"
                  />
                </Col>
                <Col span={8}>
                  <Input
                    name="shiftCode"
                    label={
                      t("shift.label.shift_code")
                    }
                    placeholder={
                      t("shift.placeholders.shift_code")
                    }
                    size="large"
                  />
                </Col>
                <Col span={8}>
                  <Select
                    name="statusFlag"
                    label={t('translation.status')}
                    placeholder={t('please-select-1')}
                    size="large"
                    options={modifiedStatus}
                  />
                </Col>

              </Row>
            )}


            <Row justify="end">
              <Space size={12} className={styles.filter}>
                <Button type="default" onClick={resetForm} style={{ height: "40px", borderRadius: "8px" }}>
                  {t("common.clear").toUpperCase()}
                </Button>
                <Button type="primary" htmlType="submit" style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)" }}>
                  {t("creatTamplete.Search").toUpperCase()}
                </Button>
              </Space>
            </Row>

          </Form>
        );
      }}
    </Formik>
  );
};

export default AttendenceFilter;
